import { render, staticRenderFns } from "./SurveyEmpBBI.vue?vue&type=template&id=bc99a45c&scoped=true&"
import script from "./SurveyEmpBBI.vue?vue&type=script&lang=js&"
export * from "./SurveyEmpBBI.vue?vue&type=script&lang=js&"
import style0 from "./SurveyEmpBBI.vue?vue&type=style&index=0&id=bc99a45c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc99a45c",
  null
  
)

export default component.exports